import { Alert, Snackbar } from '@mui/material';
import useSnackbarStore from './index';

const SnackbarComponent = () => {
  const open = useSnackbarStore((state) => state.open);
  const message = useSnackbarStore((state) => state.message);
  const severity = useSnackbarStore((state) => state.severity);
  const autoHideDuration = useSnackbarStore((state) => state.autoHideDuration);
  const hideSnackbar = useSnackbarStore((state) => state.hideSnackbar);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') return;
    hideSnackbar();
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Alert 
        onClose={handleClose} 
        severity={severity} 
        variant="filled" 
        sx={{ width: '100%' }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default SnackbarComponent;